export default "<app-navbar></app-navbar>\r\n<div class=\"container-fluid\" style=\"margin-top: 65px;\">\r\n  home\r\n</div>\r\n"